import { Service } from "typedi";
import { RestService } from "~shared/services/rest.service";
import { findIconInfoResponse, UploadIconBody, UploadIconResponse } from "@flosum-auth/contracts";

@Service()
export class IconsService {
  constructor(private readonly restService: RestService) {}

  public upload(file: UploadIconBody, iconId?: number | null): Promise<UploadIconResponse> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", file.name);

    if (iconId) {
      formData.append("iconId", iconId.toString());
    }
    return this.restService.post(`/v1/icons/upload`, formData);
  }

  public findInfo(id: number): Promise<findIconInfoResponse> {
    return this.restService.get(`/v1/icons/info/${id}`);
  }
}
